import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../../api';

export default function EtudiantEvaluations() {
  const [evals, setEvals] = useState([]);
  const [search, setSearch] = useState('');
  const [typeFilter, setTypeFilter] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (typeFilter) params.append('type_eval', typeFilter);
    API.get(`evaluations/?${params}`).then((r) => setEvals(r.data.results || r.data));
  }, [search, typeFilter]);

  const typeBadge = (t) => {
    const map = { QCM: 'badge-qcm', EXAMEN: 'badge-examen', TP: 'badge-tp', INTERRO: 'badge-interro' };
    return <span className={`badge-type ${map[t] || ''}`}>{t}</span>;
  };

  return (
    <div>
      <div className="page-header">
        <h2><i className="bi bi-clipboard-check" /> Évaluations</h2>
      </div>

      <div className="filter-bar">
        <input type="text" placeholder="Rechercher…" value={search} onChange={(e) => setSearch(e.target.value)} />
        <select value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)}>
          <option value="">Tous types</option>
          <option value="QCM">QCM</option>
          <option value="TP">TP</option>
          <option value="EXAMEN">Examen</option>
          <option value="INTERRO">Interrogation</option>
        </select>
      </div>

      {evals.length === 0 ? (
        <div className="empty-state"><i className="bi bi-clipboard-check" /><p>Aucune évaluation publiée</p></div>
      ) : (
        <div className="data-table-wrapper">
          <table className="data-table">
            <thead><tr><th>Titre</th><th>Cours</th><th>Type</th><th>Date</th><th>Durée</th><th>Barème</th><th>Action</th></tr></thead>
            <tbody>
              {evals.map((ev) => (
                <tr key={ev.id}>
                  <td>{ev.titre}</td>
                  <td>{ev.cours_titre}</td>
                  <td>{typeBadge(ev.type_eval)}</td>
                  <td>{new Date(ev.date).toLocaleDateString('fr-FR')}</td>
                  <td>{ev.duree_minutes} min</td>
                  <td>/{ev.bareme}</td>
                  <td style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    {ev.type_eval === 'QCM' ? (
                      <button className="btn btn-sm btn-primary" onClick={() => navigate(`/etudiant/qcm/${ev.id}`)}>
                        <i className="bi bi-play-fill" /> Passer
                      </button>
                    ) : (
                      <>
                        {ev.fichier_sujet_url && (
                          <a href={ev.fichier_sujet_url} target="_blank" rel="noreferrer" className="btn btn-sm btn-secondary">
                            <i className="bi bi-download" /> Sujet
                          </a>
                        )}
                        <button className="btn btn-sm btn-primary" onClick={() => navigate('/etudiant/soumissions', { state: { evaluationId: ev.id } })}>
                          <i className="bi bi-upload" /> Soumettre
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
